import styled from 'styled-components';
import css from 'styled-jsx/css';

export const Container = styled.header`
  position: relative;
  height: 768px;
  background-color: ${(props) => props.theme.colors.neutral.default};

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    height: auto;
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  z-index: 3;
  align-items: center;
  height: 100%;
  width: 100%;
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    position: initial;
  }
`;
export const Content = styled.div`
  color: ${(props) => props.theme.colors.white};
  width: 100%;
  max-width: 480px;
  display: grid;
  gap: 24px;
  justify-items: start;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    color: inherit;
    max-width: 100%;
    padding: 104px 0;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    gap: 16px;
    padding: 64px 0;

    img {
      width: 97px;
      height: 24px;
    }
  }
`;
export const Logo = styled.figure`
  margin-bottom: 8px;
  position: relative;
  display: flex;

  img {
    width: auto;
    height: auto;
    max-height: 48px;

    ${(props) =>
      props.$isDefault &&
      css`
        max-height: 28px;
      `};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    margin-bottom: 16px;

    img {
      max-height: 32px;

      ${(props) =>
        props.$isDefault &&
        css`
          max-height: 20px;
        `};
    }
  }
`;

export const Description = styled.p`
  font-family: ${(props) => props.theme.font.family.body};
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: ${(props) => props.theme.colors.white};
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    color: ${(props) => props.theme.colors.grey.dark};
    font-size: 16px;
    line-height: 28px;
  }
`;

export const WrapperText = styled.div`
  display: flex;
  width: 100%;
`;

export const VideoContainerTablet = styled.div`
  position: relative;
  aspect-ratio: 2 / 1;
  overflow: hidden;
  width: 100%;
  margin-bottom: 104px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    margin-bottom: 64px;
  }
`;
